<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <div>
            <span>员工选择：</span>
            <el-select v-model="distribution" size="small" placeholder="请选择员工">
              <el-option
                v-for="item in distributionList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <span>时间筛选：</span>
            <span>
              <el-radio-group v-model="timeTabs" size="mini">
                <el-radio-button
                  v-for="item in pickerOptions.shortcuts"
                  :key="item.text"
                  :label="item.value"
                  >{{ item.text }}</el-radio-button
                >
              </el-radio-group>
              <el-date-picker
                size="mini"
                v-model="orderTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="orderTimeChange"
              >
              </el-date-picker>
            </span>
          </div>
        </div>
        <div class="header-right"></div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="distributionList" style="width: 100%">
            <el-table-column label="员工名称">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.name }}</div>
              </template>
            </el-table-column>
            <el-table-column label="工号">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.id }}</div>
              </template>
            </el-table-column>
            <el-table-column label="劳动业绩">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.laborPerformance }}</div>
              </template>
            </el-table-column>
            <el-table-column label="劳动提成">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.laborCommission }}</div>
              </template>
            </el-table-column>
            <el-table-column label="销售业绩">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.salesPerformance }}</div>
              </template>
            </el-table-column>
            <el-table-column label="销售提成">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.salesCommission }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="small">查看明细</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="distributionList.length"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDealerListPage, getDealerChildCount, delDealer } from "@/api/index.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      statusList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "未分佣",
          value: 0,
        },
        {
          label: "已分佣",
          value: 1,
        },
      ],
      orderTime: [new Date().getTime() - 3600 * 1000 * 24 * 6, new Date()],
      timeTabs: "week",
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            value: "today",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近7日",
            value: "week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近30日",
            value: "month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近90日",
            value: "quarter",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      distribution: "",
      distributionList: [
        {
          name: "陈利武",
          id: "18",
          laborPerformance: "26580.00",
          laborCommission: "10490.00",
          salesPerformance: "3000.00",
          salesCommission: "300.00",
        },
        {
          name: "徐杰",
          id: "21",
          laborPerformance: "20680.00",
          laborCommission: "8408.00",
          salesPerformance: "4600.00",
          salesCommission: "520.00",
        },
        {
          name: "吴更雯",
          id: "31",
          laborPerformance: "22768.00",
          laborCommission: "9860.00",
          salesPerformance: "7000.00",
          salesCommission: "1400.00",
        },
        {
          name: "李纤",
          id: "32",
          laborPerformance: "17768.00",
          laborCommission: "8640.00",
          salesPerformance: "4000.00",
          salesCommission: "800.00",
        },
      ],
      pageSize: 10,
      pageCount: 0,
      pageNo: 1,
      phoneNum: "",
      distributionCount: 0,
    };
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
  },
  watch: {
    time(val) {
      console.log(val);
      if (val) {
        this.startTime = new Date(val[0]).pattern("yyyy-MM-dd");
        this.endTime = new Date(val[1]).pattern("yyyy-MM-dd");
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },
  },
  mounted() {
    // this.getPageData();
  },
  methods: {
    getPageData() {
      this.pageNo = 1;
      this.getDealerListPage();
      // this.getDealerChildCount();
    },
    getDealerListPage() {
      getDealerListPage({
        pageNumber: this.pageNo,
        pageSize: this.pageSize,
        phoneNum: this.phoneNum,
      }).then((res) => {
        if (res.code == 1) {
          this.distributionList = res.data.list;
          this.pageCount = res.data.totalCount;
        }
        if (res.code == -1) {
          this.distributionList = [];
          this.pageCount = 0;
        }
      });
    },
    getDealerChildCount() {
      getDealerChildCount().then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.distributionCount = res.data.totalCount;
        }
      });
    },
    searchDistribution() {
      this.getPageData();
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getDealerListPage();
    },
    linkToRelationship(userId) {
      this.$router.push({
        path: "/distribution/relationship",
        query: {
          userId: userId,
        },
      });
    },
    showChiefQrcode(id) {},
    delDealer(item) {
      console.log(item);
      this.$confirm("此操作将永久删除, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        delDealer({
          shopMemberId: item.shopMemberId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "删除成功",
              type: "success",
              duration: 1000,
            });
            this.getDealerListPage();
          } else {
            this.$notify.error("错误", res.msg);
          }
        });
      });
    },
    orderTimeChange(e) {
      this.getStatisticsOrdersByDate();
      this.timeTabs = "";
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .header-left {
    height: 30px;
    align-items: center;
    & > div {
      margin-right: 10px;
      display: flex;
      align-items: center;
      & > span {
        display: flex;
        align-items: center;
      }
      .el-radio-group {
        margin-right: 10px;
      }
    }
  }
  .header-right {
    & > div {
      .el-input {
        display: inline-block;
        width: 130px;
      }
    }
    & > div + div {
      margin-left: 10px;
    }
    .el-button {
      margin-left: 10px;
    }
  }
  .upload-xls {
    margin: 0 10px;
  }
  .list {
    width: 100%;
    padding: 0 20px;
    .template-name {
      color: #66b1ff;
      cursor: pointer;
    }
    .status {
      display: inline-block;
      width: 70px;
      margin-right: 5px;
      &.ing {
        color: #ffaa00;
      }
      &.suc {
        color: #7abd54;
      }
      &.fail {
        color: #ff4c4c;
      }
    }
  }
  .tips {
    border: 1px solid #ff9191;
    background-color: #ffe6e6;
    display: block;
    position: relative;
    color: #666;
    font-size: 12px;
    line-height: 30px;
    padding: 8px;
    border-radius: 3px;
    .em {
      color: #3388ff;
    }
  }
}
.popover {
  .title {
    line-height: 30px;
  }
  .content {
    color: #66b1ff;
  }
}
</style>

<style lang="less">
.upload-xls-btn {
  display: inline-block;
  margin: 0 10px;
}
</style>
